const lang = {
    ja: {
        'errorPage.403': 'このページにアクセスする権限がありません。',
        'errorPage.404': 'このページが存在しません。',
    },
    en: {
        'errorPage.403': 'You are not authorized to access this page.',
        'errorPage.404': 'This page does not exist.',
    },
};

export default lang;
